import { getLanguage } from "../store/translations/hooks";

export const paths = {
    anonymousSchedule: () => `/${getLanguage()}/anonymous/schedule`,
    root: () => `/${getLanguage()}/`,
    login: () => `/${getLanguage()}/login`,
    loginProfessional: () => `/${getLanguage()}/login/professional`,
    loginProfessionalOnboarding: () => `/${getLanguage()}/login/professional/onboarding`,
    loginClient: () => `/${getLanguage()}/login/client`,
    noClinics: () => `/${getLanguage()}/no-clinics`,
    users: () => `/${getLanguage()}/users`,
    account: () => `/${getLanguage()}/account`,
    profile: () => `/${getLanguage()}/profile`,
    clients: () => `/${getLanguage()}/clients`,
    client: (id: string) => `/${getLanguage()}/clients/${id}`,
    tasks: () => `/${getLanguage()}/tasks`,
    professionals: () => `/${getLanguage()}/professionals`,
    stock: () => `/${getLanguage()}/stock`,
    settings: () => `/${getLanguage()}/settings`,
    clientsIntelligentCategorizationSettings: () => `/${getLanguage()}/settings/clients-intelligent-categorization`,
    settingsUsers: () => `/${getLanguage()}/settings/users`,
    billing: () => `/${getLanguage()}/billing`,
    admin: () => `/${getLanguage()}/admin`,
    analytics: () => `/${getLanguage()}/analytics`,
    administratorDashboard: () => `/${getLanguage()}/admin`,
    actionResult: () => `/${getLanguage()}/action-result`,
    campaigns: () => `/${getLanguage()}/campaigns`,
    campaign: (id: string) => `/${getLanguage()}/campaigns/${id}`,
    campaignAnalytics: (id: string) => `/${getLanguage()}/campaigns/${id}/analytics`,
    myPacks: () => `/${getLanguage()}/my-packs`,
    mySubscription: () => `/${getLanguage()}/my-subscription`,
    help: () => `/${getLanguage()}/help`,
    clientConsent: () => `/client/consent`,
    clientSurvey: () => `/client/survey`,
    clientSurveyPreview: () => `/client/survey-preview`,
    confirmEmailAction: () => `/action/confirm-email`,
    resetPasswordAction: () => `/action/reset-password`,
    cashRegister: () => `/${getLanguage()}/cash-register`,
    waitingLists: () => `/${getLanguage()}/waiting-lists`,
    waitingListSettings: () => `/${getLanguage()}/settings/waiting-list`,
} 
